import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error404: FC = () => {
  return (
    <div className='d-flex flex-column flex-center text-center p-10'>
      {/* University-branded header */}
      <div className='mb-10'>
        <img
          src={toAbsoluteUrl('/media/logo/main-logo.png')}
          alt='University Logo'
          className='h-75px'
        />
      </div>

      {/* Error indicator */}
      <div className='error-code fw-bolder fs-2hx text-danger mb-4'>404</div>

      {/* Formal title */}
      <h1 className='fw-bolder fs-1 mb-6 text-gray-800'>Page Not Found</h1>

      {/* Professional explanation */}
      <div className='fw-semibold fs-4 text-gray-600 mb-8'>
        The requested resource could not be located on this server.
        <br />
        Please verify the URL or navigate using the menu options.
      </div>

      <div className='d-flex flex-center gap-4'>
        <Link to='/dashboard' className='btn btn-lg btn-primary px-6 py-3'>
          <i className='fas fa-home me-2'></i> Return to Home
        </Link>
      </div>

      {/* Technical assistance */}
      <div className='mt-10 text-gray-500 fs-6'>
        If you believe this is an error, please contact the
        <a href='mailto:it-support@university.edu' className='ms-1'>
          IT Support Center
        </a>
        .<div className='mt-2'>Error Code: 404-UNI-MIS</div>
      </div>
    </div>
  )
}

export {Error404}
